<form
  id="transferForm"
  [formGroup]="transferForm"
  *ngIf="transferForm"
  ngSubmit="onSubmit"
>
  <p class="mat-body-1">
    {{ "TransferForm.TransferFormSubTitle" | translate }}
  </p>
  <br />
  <h3 class="mat-subheading-1" *ifPermissions="['Engage Transfer']">
    {{ "TransferForm.TransferType" | translate }}
  </h3>
  <div class="radio-input-container" *ifPermissions="['Engage Transfer']">
    <input
      formControlName="accountType"
      value="License Management Account"
      for="license-management-account"
      name="accountType"
      type="radio"
      (ngModelChange)="clearInput('email')"
    />
    <h3 name="license-management-account">
      {{ "TransferForm.LicenseManagement" | translate }}
    </h3>
  </div>

  <div
    class="radio-input-container"
    *ifPermissions="['Engage Support', 'Internal Admin']"
  >
    <input
      formControlName="accountType"
      value="Company Search"
      for="company-search"
      name="accountType"
      type="radio"
      (ngModelChange)="clearInput('siteId')"
    /><label name="company-search">{{
      "TransferForm.CompanySearch" | translate
    }}</label>
  </div>

  <div class="radio-input-container">
    <input
      formControlName="accountType"
      value="ENGAGE™ Account"
      for="engage-account"
      name="accountType"
      type="radio"
      (ngModelChange)="clearInput('accountId')"
    />
    <h3 name="engage-account">
      {{ "TransferForm.EngageAccount" | translate }}
    </h3>
  </div>

  <h3>{{ "TransferForm.RecipientDetails" | translate }}</h3>
  <br />

  <div
    class="input-container"
    *ngIf="transferForm.value.accountType === 'Company Search'"
  >
    <label for="company-search">{{ "Search.Placeholder" | translate }}</label
    ><br />
    <input
      formControlName="accountId"
      type="text"
      id="company-account-id"
      name="company-account-id"
      [matAutocomplete]="auto"
      matInput
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayName.bind(this)"
    >
      <mat-option
        *ngFor="let option of filteredOptions | async"
        [value]="option"
      >
        {{ option.businessId }} (Account # {{ option.accountNumber || "WTF" }})
      </mat-option>
    </mat-autocomplete>
  </div>
  <div
    class="error-text-container"
    *ngIf="
    transferForm.get('accountId')?.errors?.['invalid']
  "
  >
    <mat-icon style="color: red">error_outline</mat-icon>
    <p class="error-text">
      {{ transferForm.get('accountId')?.errors?.['message'] }}
    </p>
  </div>

  <div
    class="input-container"
    *ngIf="transferForm.value.accountType === 'License Management Account'"
  >
    <label for="recipient-email">{{
      "TransferForm.RecipientEmail" | translate
    }}</label
    ><br />
    <input
      formControlName="email"
      type="email"
      id="recipient-email"
      name="recipient-email"
      maxlength="1024"
      pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
      title="Invalid Email Address"
    />
    <div
      class="error-text-container"
      *ngIf="
        transferForm.get('email')?.errors?.['invalid']
      "
    >
      <mat-icon style="color: red">error_outline</mat-icon>
      <p class="error-text">
        {{ transferForm.get('email')?.errors?.['message'] }}
      </p>
    </div>
  </div>

  <div
    class="input-container"
    *ngIf="transferForm.value.accountType === 'ENGAGE™ Account'"
  >
    <label for="site-id">{{ "TransferForm.RecipientSiteID" | translate }}</label
    ><br />

    <input
      (blur)="displaySiteIdName(transferForm.get('siteId')?.value)"
      formControlName="siteId"
      type="number"
      (keypress)="numericOnly($event)"
      id="site-id"
      name="site-id"
      maxlength="128"
    />
    <span class="mat-body-1">
      {{ "TransferReview.RecipientInfoReview" | translate }}:
    </span>
    <span>{{ siteIdDisplay }}</span>
    <app-loading-animation *ngIf="loading"></app-loading-animation>
    <div
      class="error-text-container"
      *ngIf="transferForm.get('siteId')?.errors?.['invalid']"
    >
      <mat-icon style="color: red">error_outline</mat-icon>
      <p class="error-text">
        {{ "TransferForm.ErrorSiteID" | translate }}
        <a href="mailto:mobilecredentials@allegion.com?subject=subject text"
          >mobilecredentials&#64;allegion.com</a
        >.
      </p>
    </div>
  </div>

  <h3>{{ "TransferForm.CreditDetails" | translate }}</h3>
  <div class="input-container">
    <label>{{ "TransferForm.CreditType" | translate }}</label
    ><br />
    <select formControlName="productType" [selectedIndex]="categorySelection">
      <option #option *ngFor="let product of products" [ngValue]="product">
        {{ product.name }}
      </option>
    </select>
  </div>

  <div class="input-container">
    <label *ifPermissions="['Engage Transfer']" for="credit-quantity">{{
      "TransferForm.CreditAmountTransfer" | translate
    }}</label>
    <label
      *ifPermissions="['Engage Support', 'Internal Admin']"
      for="credit-quantity"
      >{{ "TransferForm.CreditAmountGenerate" | translate }}</label
    ><br />

    <input
      (wheel)="onMouseWheel($event)"
      (keypress)="numericOnly($event)"
      formControlName="quantity"
      type="number"
      id="credit-quantity"
      name="credit-quantity"
      min="0"
      pattern="\d*"
    />

    <div
      *ngIf="transferForm.get('quantity')?.errors?.['invalid']"
      class="error-text-container"
    >
      <mat-icon style="color: red">error_outline</mat-icon>
      <p class="error-text">
        {{ "TransferForm.AmountExceeded" | translate }}
      </p>
    </div>
  </div>

  <div class="input-container" *ifPermissions="['Engage Transfer']">
    <label for="po-number"
      >{{ "TransferForm.PONumber" | translate }}
      <span
        >({{ "TransferForm.TransferFormOptional" | translate }} -
        {{ poCharsLeft }}
        {{ "TransferForm.CharactersRemaining" | translate }})</span
      >
    </label>
    <br />
    <input
      formControlName="purchaseOrder"
      type="text"
      id="po-number"
      name="po-number"
      maxLength="64"
      [(ngModel)]="poCurrentText"
      (input)="poChanged($event)"
    />
    <div
      *ngIf="transferForm.get('purchaseOrder')?.errors?.['invalid']"
      class="error-text-container"
    >
      <mat-icon style="color: red">error_outline</mat-icon>
      <p class="error-text">
        {{ "TransferForm.PurchaseOrderError" | translate }}
      </p>
    </div>
  </div>

  <div class="input-container">
    <label for="notes"
      >{{ "TransferForm.TransferFormNotes" | translate }}
      <span
        >({{ "TransferForm.TransferFormOptional" | translate }} -
        {{ notesCharsLeft }}
        {{ "TransferForm.CharactersRemaining" | translate }})</span
      ></label
    ><br />
    <textarea
      formControlName="notes"
      type="text"
      id="notes"
      name="notes"
      maxlength="512"
      [(ngModel)]="notesCurrentText"
      (input)="notesChanged($event)"
    >
    </textarea>

    <br />

    <div
      *ngIf="transferForm.get('notes')?.errors?.['invalid']"
      class="error-text-container"
    >
      <mat-icon style="color: red">error_outline</mat-icon>
      <p class="error-text">
        {{ "TransferForm.NotesError" | translate }}
      </p>
    </div>
  </div>

  <div class="buttons-container">
    <app-button
      buttonColor="accent"
      [buttonText]="'TransferForm.TransferFormClear' | translate"
      buttonClass="buttonStyle buttonStyle-outlined"
      (click)="clearForm()"
    ></app-button>
    <button
      *ifPermissions="['Engage Transfer']"
      type="button"
      mat-flat-button
      color="primary"
      [ngClass]="{
        disabled: transferForm.invalid,
        'continue-button': true
      }"
      [disabled]="transferForm.invalid"
      class="continue-button"
      (click)="validateData.emit()"
    >
      {{ "TransferForm.TransferFormContinue" | translate }}
    </button>
    <button
      *ifPermissions="['Engage Support', 'Internal Admin']"
      type="button"
      mat-flat-button
      color="primary"
      [ngClass]="{
        disabled: transferForm.invalid,
        'continue-button': true
      }"
      [disabled]="transferForm.invalid"
      class="continue-button"
      (click)="validateSupportData.emit()"
    >
      {{ "TransferForm.TransferFormContinue" | translate }}
    </button>
  </div>
</form>
